import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { BptSearchModule } from 'bpt-ui-library/bpt-search';
import { TooltipModule } from 'primeng/tooltip';
import { FormsModule } from '@angular/forms';
import { EmptyResultsComponent } from '../shared-components/empty-results/empty-results.component';
import { SpinnerComponent } from '../shared-components/spinner/spinner.component';
import { PanelHubComponent } from '../shared-components/panel-hub/panel-hub.component';
import { SkillSearchComponent } from './components/skill-search.component';

@NgModule({
  declarations: [SkillSearchComponent],
  imports: [
    CommonModule,
    SharedModule,
    BptSearchModule,
    TooltipModule,
    FormsModule,
    EmptyResultsComponent,
    SpinnerComponent,
    PanelHubComponent
  ],
  exports: [SkillSearchComponent]
})
export class SkillSearchModule { }
